import BasicService from "./BasicService";

class IncomeReportService extends BasicService {
    constructor() {
        super();
    }
    getIncomeReportList(fromDate, toDate, typeId, type, userAccountId) {
        let url = `/report/incomes`;
        return this.axios.get(url, {
            params: {
                fromDate,
                toDate,
                typeId,
                type,
                userAccountId,
            }
        }).then(request => request.data);
    }
}

const incomeReportService = new IncomeReportService();
export default incomeReportService;